import { Options, Vue } from 'vue-class-component';
import PageHeader from '@/components/header/page-header/index.vue';
import PageFooter from '@/components/page-footer/index.vue';
import { Prop } from 'vue-property-decorator';

@Options({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class StdPageLayout extends Vue {
  @Prop({ default: false })
  private showAccountControl!: boolean;
}


